import { Gesture } from "@use-gesture/vanilla";

export default class GestureService {

    private pinchGesture?: Gesture;

    constructor() {
    }

    enablePinchZoom(guideWrapper: HTMLElement, parent?: HTMLElement | null) {
        if (!guideWrapper) return;

        const MIN_SCALE = 1;
        const MAX_SCALE = 5;
        let initialScale = MIN_SCALE;

        const DOUBLE_TAP_THRESHOLD = 500;
        let lastTap = 0;

        this.pinchGesture = new Gesture(guideWrapper as HTMLElement, {
            // onPinch: (state) => {
            //     let pinchScale = state.offset[0];

            //     if (pinchScale > MAX_SCALE) pinchScale = MAX_SCALE;
            //     else if (pinchScale < MIN_SCALE) pinchScale = MIN_SCALE;

            //     initialScale = pinchScale;

            //     guideWrapper.style.transformOrigin = '0px 0px';
            //     guideWrapper.style.scale = `${initialScale}`;
            //     if (parent) {
            //         parent.scrollTo(state.origin[0], state.origin[1]);
            //     }
            // },
            onWheel: (state) => {
                if (state.ctrlKey) {
                    let wheelScale = initialScale + state.movement[0] / 1000;

                    if (wheelScale > MAX_SCALE) wheelScale = MAX_SCALE;
                    else if (wheelScale < MIN_SCALE) wheelScale = MIN_SCALE;

                    initialScale = wheelScale;

                    guideWrapper.style.transformOrigin = '0px 0px';
                    guideWrapper.style.scale = `${initialScale} ${initialScale}`;
                    if (parent) {
                        parent.scrollTo(state.xy[0], state.xy[1]);
                    }
                }
            },
            onDrag: (state) => {
                if (state.tap) {
                    const now = Date.now();
                    if (Math.abs(now - lastTap) <= DOUBLE_TAP_THRESHOLD) {
                        lastTap = 0;
                        if (initialScale > MIN_SCALE) {
                            initialScale = MIN_SCALE;

                            guideWrapper.style.transformOrigin = 'unset';
                            guideWrapper.style.scale = 'unset';
                        } else {
                            initialScale = 2;

                            guideWrapper.style.transformOrigin = '0px 0px';
                            guideWrapper.style.scale = `${initialScale} ${initialScale}`;
                            if (parent) {
                                parent.scrollTo(state.xy[0], state.xy[1]);
                            }
                        }
                    } else {
                        lastTap = now;
                    }
                }
            }
        });
    }

    disablePinchZoom() {
        if (this.pinchGesture) {
            this.pinchGesture.destroy();
        }
    }
}